import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { useAuth } from "@/context/AuthContext";
import { useFavorites } from "@/context/FavoritesContext";
import ProductCard from "@/components/ProductCard";
import { Button } from "@/components/ui/button";
import { Heart, Loader2 } from "lucide-react";

export default function Favorites() {
  const { t } = useI18n();
  const { user, ready } = useAuth();
  const { ids } = useFavorites();
  const navigate = useNavigate();
  const [products, setProducts] = useState(null);

  useEffect(() => {
    if (ready && user === false) navigate("/login");
  }, [ready, user, navigate]);

  useEffect(() => {
    if (user) api.get("/favorites").then((r) => setProducts(r.data)).catch(() => setProducts([]));
  }, [user, ids.size]);

  if (!products) return <div className="py-32 flex justify-center"><Loader2 className="h-6 w-6 animate-spin text-[#0EA5E9]" /></div>;

  return (
    <div className="max-w-7xl mx-auto px-5 py-10">
      <div className="flex items-center gap-3 mb-8">
        <Heart className="h-6 w-6 text-red-500 fill-red-500" />
        <h1 className="font-display text-3xl md:text-4xl font-extrabold text-[#0F172A]">{t("fav.title")}</h1>
      </div>
      {products.length === 0 ? (
        <div className="text-center py-24" data-testid="favorites-empty">
          <div className="h-16 w-16 rounded-2xl bg-red-50 text-red-500 flex items-center justify-center mx-auto mb-5"><Heart className="h-8 w-8" /></div>
          <p className="text-[#475569] mb-6">{t("fav.empty")}</p>
          <Link to="/explore"><Button className="rounded-full bg-[#0F172A] text-white">{t("fav.explore")}</Button></Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6" data-testid="favorites-grid">
          {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
